module.exports = __webpack_public_path__ + "img/dropbox-circle.fd2bc439.svg";